<div class="modal-container">
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h2 mat-dialog-title>Capacidad por Días - Polígono {{data.ID_POLI}}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="modal-content">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <span>Listado de Capacidades por Días</span>
        <div class="d-flex align-items-center gap-2">
          <mat-form-field appearance="fill" class="search-field">
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Buscar capacidad">
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
      </div>

      <div class="card-body" *ngIf="capacidadesDias.length === 0">
        <p class="text-center">No hay capacidades por días para mostrar</p>
      </div>

      <div class="card-body overflow-auto" *ngIf="capacidadesDias.length > 0">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="ID_REG_CAL">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">ID</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{element.ID_REG_CAL}}</td>
          </ng-container>

          <ng-container matColumnDef="COD_BODEGA">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">BODEGA</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{element.COD_BODEGA}}</td>
          </ng-container>

          <ng-container matColumnDef="FECHA_DIA">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">FECHA DÍA</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{formatDate(element.FECHA_DIA)}}</td>
          </ng-container>

          <ng-container matColumnDef="CUBICAJE_TOTAL">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">CUBICAJE TOTAL</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{element.CUBICAJE_TOTAL}}</td>
          </ng-container>

          <ng-container matColumnDef="CANTIDAD_ORD_TOTAL">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">CANTIDAD ÓRDENES</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{element.CANTIDAD_ORD_TOTAL}}</td>
          </ng-container>

          <ng-container matColumnDef="CIERRE_AUTOMATICO">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">CIERRE AUTO</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{element.CIERRE_AUTOMATICO === 'S' ? 'Sí' : 'No'}}</td>
          </ng-container>

          <ng-container matColumnDef="PORCENTAJE_CIERRE">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">% CIERRE</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{element.PORCENTAJE_CIERRE}}%</td>
          </ng-container>

          <ng-container matColumnDef="ESTADO">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">ESTADO</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">
              <span [class]="element.ESTADO === 'A' ? 'badge-active' : 'badge-inactive'">
                {{element.ESTADO === 'A' ? 'Activo' : 'Inactivo'}}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="USUARIO_CREACION">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">USUARIO CREACIÓN</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">
              {{element.USUARIO_CREACION}}<br>
              <small>{{formatDateTime(element.FECHA_CREACION)}}</small>
            </td>
          </ng-container>

          <ng-container matColumnDef="ACCIONES">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">ACCIONES</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">
              <button mat-icon-button matTooltip="Editar" (click)="iniciarEdicion(element)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Eliminar" (click)="confirmarEliminarDia(element)">
                <mat-icon style="color: #e53935">delete</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Alertas" (click)="abrirModalAlertas(element)">
                <mat-icon>notifications</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons></mat-paginator>
    </div>
  </div>

  <div mat-dialog-actions class="modal-actions">
    <button mat-button mat-dialog-close>Cerrar</button>
  </div>
</div>

<!-- Template del diálogo de edición de capacidad por día -->
<ng-template #editDiaDialog>
  <h2 mat-dialog-title class="d-flex align-items-center gap-2">
    <mat-icon>edit</mat-icon>
    Editar Capacidad por Día
  </h2>
  <div mat-dialog-content>
    <div class="row g-3">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fecha Día</mat-label>
          <input matInput type="date" [(ngModel)]="editForm.FECHA_DIA">
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Cierre Automático</mat-label>
          <mat-select [(ngModel)]="editForm.CIERRE_AUTOMATICO">
            <mat-option value="S">Sí</mat-option>
            <mat-option value="N">No</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12" *ngIf="editForm.CIERRE_AUTOMATICO === 'S'">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>% Cierre</mat-label>
          <input matInput type="number" min="1" max="100" [(ngModel)]="editForm.PORCENTAJE_CIERRE">
          <span matSuffix>%</span>
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Cubicaje Total</mat-label>
          <input matInput type="number" step="0.01" min="0" [(ngModel)]="editForm.CUBICAJE_TOTAL">
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Cantidad Órdenes Total</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="editForm.CANTIDAD_ORD_TOTAL">
        </mat-form-field>
      </div>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="cancelarEdicion()">
      <mat-icon>close</mat-icon> Cancelar
    </button>
    <button mat-raised-button color="primary" (click)="guardarEdicion()">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </div>
</ng-template>